export default {
  startDate: null,
  endDate: null,
  currentPage: 1,
}
